// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubscribeAndSaveDetails_wrapper__3irDV"};